"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/components/FormWrapper.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _AuthFrame = require('web/components/AuthFrame');








// A sign-in card's contents: an optional back chevron, the title, the form.
const FormWrapper = ({ title, onBack, children, className }) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, "auth-stack", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
    ,  onBack && _react2.default.createElement(_AuthFrame.BackButton, { onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}} ) 
    , _react2.default.createElement('h1', { className: "auth-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}},  title )
    ,  children 
  )
)

exports. default = FormWrapper
